import { resetCsrfToken } from '@/graphql/client';

import { fetchCsrf, fetchHttp } from './useRequest';
import { userState } from './useUser';

export const login = async (
    payload: Record<string, unknown>
): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp('/login', {
        method: 'post',
        body: JSON.stringify(payload)
    });
};

export const logout = async (): Promise<Response> => {
    const result = await fetchHttp('/logout', { method: 'post' });

    userState.clear();
    resetCsrfToken();

    return result;
};

export const forgotPassword = async (
    payload: Record<string, unknown>,
    organizationPrefixedId: string
): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp('/forgot-password', {
        method: 'post',
        body: JSON.stringify(payload),
        headers: { 'X-Requested-By': organizationPrefixedId }
    });
};

export const resetPassword = async (
    payload: Record<string, unknown>
): Promise<Response> => {
    await fetchCsrf();

    return fetchHttp('/reset-password', {
        method: 'post',
        body: JSON.stringify(payload)
    });
};
